import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MyPoint, UserPointTransaction } from 'app/core/models';
import { environment } from '../../../environments';

const basePath = `${environment.apiBaseUrl}user-points`;

@Injectable({
  providedIn: 'root',
})
export class UserPointClient {
  private readonly _http = inject(HttpClient);

  getMyPoints(): Observable<MyPoint> {
    return this._http.get<MyPoint>(`${basePath}`);
  }

  refreshMyPoints(): Observable<UserPointTransaction | null | undefined> {
    return this._http.put<UserPointTransaction | null | undefined>(`${basePath}/refresh`, undefined);
  }
}
